// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__AL7WT","actionsCol":"EnrolledClinics_actionsCol__3g4qX"};